import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosNewtur = {
    ...dadosAgenciaComum,
    id: 'newtur',
    nome: 'Newtur',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-NHVKV45']
};
